import * as Sentry from '@sentry/react';
import React from 'react';
import { Route as _Route, Routes as ReactRouterRoutes } from 'react-router';

import { PATHS } from '@/shared/config';

import { AddDiagnocoins } from '@/pages/AddDiagnocoins/AddDiagnocoins';
import { AddPackages } from '@/pages/AddPackages/AddPackages';
import { AddSubscription } from '@/pages/AddSubscription/AddSubscription';
import { Home } from '@/pages/Home/Home';
import { Organization } from '@/pages/Organization/Organization';
import { OrganizationContainer } from '@/pages/OrganizationContainer/OrganizationContainer';
import { ProductEditor } from '@/pages/ProductEditor/ProductEditor';
import { SignIn } from '@/pages/SignIn/SignIn';
import { User } from '@/pages/User/User';
import { UserContainer } from '@/pages/UserContainer/UserContainer';

import { ProtectedRoutes } from '../providers/ProtectedRoutes';

const Route = Sentry.withSentryReactRouterV6Routing(_Route);

export const Routes = (): React.ReactElement => (
  <ReactRouterRoutes>
    <Route path={PATHS.signIn} element={<SignIn />} />

    <Route element={<ProtectedRoutes />}>
      <Route path={PATHS.main} element={<Home />} />
      <Route path={PATHS.productEditor} element={<ProductEditor />} />
      <Route path={PATHS.user} element={<UserContainer />}>
        <Route index element={<User />} />
      </Route>
      <Route path={PATHS.organization} element={<OrganizationContainer />}>
        <Route index element={<Organization />} />
        <Route path={PATHS.addSubscription} element={<AddSubscription />} />
        <Route path={PATHS.addPackage} element={<AddPackages />} />
        <Route
          path={PATHS.addDiagnocoins}
          element={<AddDiagnocoins />}
        />
      </Route>
    </Route>
    {/* TODO: Implement error page */}
    {/* <Route path={PATHS.error} element={<ErrorPage />} /> */}
  </ReactRouterRoutes>
);
